import { plainToClass } from "class-transformer";
import { GET_DATA_DEFINITIONS, GET_PROPERTY_UNITS } from "../queries";
import { Definition } from "./Definition";

export const isProperty = (item: any): boolean => {
    return item.hasOwnProperty('property') && typeof item.property === 'string' ;
}

export const isEntity = (item: any): boolean => {
    return item.hasOwnProperty('entity_type');
}

export const isTimestampProperty = (item: any): boolean => {
    return isProperty(item) && item.type === 'timestamp';
}

export const isLookupProperty = (item: any): boolean => {
    return isProperty(item) && item.type === 'property_lookup';
}

export const isStats = (item: any): boolean => {
    return isProperty(item) && item.type === 'stats';
}

export const getDataDefinitions = (client:any) => {
    return client.query({
        query: GET_DATA_DEFINITIONS
    }).then(({data}:any) => {
        // make typed.
        data.syncarto_app_data_definition.forEach((d:any) => {
            d.definition = plainToClass(Definition, d.definition)
            d.definition.id = d.id;
        });

        return data.syncarto_app_data_definition;
    });
}